export function decodeBase64(base64Data: string) {
	if (base64Data.startsWith('data:text/html;base64,')) {
		base64Data = base64Data.substring(22);
	}

	let binaryString = atob(base64Data);
	let binaryLen = binaryString.length;
	let bytes = new Uint8Array(binaryLen);
	[...binaryString].forEach((char, index) => {
		bytes[index] = char.charCodeAt(0);
	});

	return new TextDecoder('utf-8').decode(bytes);
}
